import { RoleType } from './role-type';

export interface User {
  id: string;
  isActive: boolean;
  roleType: RoleType;
  roleLabel?: string;
  fullName?: string;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  barcode: string;
  pin: string;
  token?: string;
  termsAccepted?: boolean;
}

export function GetBlankUser(): User {
  return {
    id: '',
    isActive: true,
    roleType: RoleType.Unknown,
    username: '',
    password: '',
    firstName: '',
    lastName: '',
    email: '',
    barcode: '',
    pin: ''
  };
}


// WEBPACK FOOTER //
// ./src/types/user.ts